import { HiveMention } from './hive-mention';

export function effects() {
  customElements.define('hive-mention', HiveMention);
}

declare global {
  interface HTMLElementTagNameMap {
    'hive-mention': HiveMention;
  }
}
